import { render, staticRenderFns } from "./versionFormOffline.vue?vue&type=template&id=142731dc"
import script from "./versionFormOffline.vue?vue&type=script&lang=js"
export * from "./versionFormOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports